import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/policy", label: "Policy" },
  { to: "/beliefs", label: "Beliefs" },
  { to: "/donate", label: "Donate" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed left-0 right-0 top-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "border-b border-hairline/70 bg-navy/70 py-3 backdrop-blur-xl" : "border-b border-transparent py-5"
      }`}
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-5 md:px-10">
        <Link to="/" data-testid="logo-link" className="group flex items-center gap-3">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-kinetic text-xs font-bold text-white">★</span>
          <span className="font-display text-lg font-bold tracking-tight text-bone md:text-xl">
            PRASCAK <span className="text-kinetic">4</span> PRESIDENT
          </span>
        </Link>

        <div className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`link-underline text-sm uppercase tracking-[0.18em] transition-colors duration-300 ${
                location.pathname === l.to ? "text-bone" : "text-bone/60 hover:text-bone"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <button
            data-testid="nav-donate-btn"
            onClick={() => navigate("/donate")}
            className="rounded-full bg-kinetic px-6 py-2.5 text-sm font-semibold uppercase tracking-wider text-white transition-transform duration-300 hover:-translate-y-0.5 hover:bg-[#f03528]"
          >
            Donate
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="text-bone md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="mt-3 border-t border-hairline/60 bg-navy/95 px-5 py-6 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="text-lg uppercase tracking-widest text-bone/80">
                {l.label}
              </Link>
            ))}
            <button
              onClick={() => navigate("/donate")}
              className="mt-2 rounded-full bg-kinetic px-6 py-3 text-sm font-semibold uppercase tracking-wider text-white"
            >
              Donate
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
